<template>
  <a-layout-content class="wemail-sites-overview">
    <a-breadcrumb :style="{ marginBottom: '20px' }">
      <a-breadcrumb-item>
        <router-link tag="a" :to="{ name: 'sites.overview', params: { siteId: this.$route.params.siteId } }">Site</router-link>
      </a-breadcrumb-item>
      <a-breadcrumb-item>Events & Logs</a-breadcrumb-item>
    </a-breadcrumb>
    <div class="wemail-tabs-wrap">
      <SitesNavigation/>
      <div class="wemail-overview-content">
        <section>
          <a-row :style="{ marginTop: '10px', marginBottom: '20px', fontSize: '1.2em' }">
            <a-col :span="24" :style="{ padding: '10px', background: '#fff' }">
              {{ status | capitalize }} Events & Log
              <a-select v-model="status" @change="handleChange" :style="{ float: 'right', marginTop: '-2px' }">
                <a-select-option value="all">All Events & Logs</a-select-option>
                <a-select-option value="success">Success Events & Logs</a-select-option>
                <a-select-option value="failed">Failed Events & Logs</a-select-option>
              </a-select>
            </a-col>
          </a-row>

          <CampaignsTable
              :loading="loading"
              :dataSource="events"
              @pagination="pagination"
          ></CampaignsTable>

        </section>
      </div>
    </div>
  </a-layout-content>
</template>

<script>
import SitesNavigation from "@/components/SitesNavigation.vue";
import CampaignsTable from "@/components/Campaigns/CampaignsTable";
import {mapGetters} from "vuex";

export default {
  components: { SitesNavigation, CampaignsTable },
  data() {
    return {
      status: 'all',
      loading: true
    };
  },
  methods: {
    async dispatchActions(page = 1) {
      this.loading = true;
      await this.$store.dispatch("campaigns/ALL_EVENTS_LOGS", {
        page: page,
        site: this.$route.params.siteId,
        status: this.status,
        context: this
      });
    },
    pagination: function(page) {
      this.dispatchActions(page);
    },
    handleChange() {
      this.dispatchActions();
    }
  },
  computed: {
    ...mapGetters({
      events: "campaigns/getEvents"
    })
  },
  mounted() {
    this.dispatchActions();
  }
};
</script>
<style  scoped>
.wemail-sites-overview {
  margin: 30px;
}
.wemail-overview-content {
  padding: 15px;
  background: #fafafa;
}
.wemail-overview-content table {
  border: 1px solid #e8e8e8;
}
.wemail-tabs-wrap {
  border: 1px solid #d9d9d9;
}
</style>
